namespace GeniuzPOS.InitialData {
    export interface PsConnectEdcBankRow {
        Id?: number;
        EdcBank?: string;
        EdcBankName?: string;
        Remark?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsConnectEdcBankRow {
        export const idProperty = 'EdcBank';
        export const nameProperty = 'EdcBankName';
        export const localTextPrefix = 'InitialData.PsConnectEdcBank';
        export const lookupKey = 'InitialData.PsConnectEdcBank';

        export function getLookup(): Q.Lookup<PsConnectEdcBankRow> {
            return Q.getLookup<PsConnectEdcBankRow>('InitialData.PsConnectEdcBank');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Modify';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Modify';

        export declare const enum Fields {
            Id = "Id",
            EdcBank = "EdcBank",
            EdcBankName = "EdcBankName",
            Remark = "Remark",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
